import { render, staticRenderFns } from "./create-dialog.vue?vue&type=template&id=280246a9&"
import script from "./create-dialog.vue?vue&type=script&lang=js&"
export * from "./create-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports